import { APP_BASE_HREF, isPlatformServer } from '@angular/common';
import { Inject, Injectable, LOCALE_ID, PLATFORM_ID } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { AuthenticationFacade } from '@planone/bau365/data-access-authentication';
import { KeycloakService } from 'keycloak-angular';
import { map, Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class BusinessCardAuthenticatedGuard {
  private authenticated$: Observable<boolean>;

  constructor(
    authFacade: AuthenticationFacade,
    private keycloak: KeycloakService,
    @Inject(APP_BASE_HREF) private baseHref: string,
    @Inject(LOCALE_ID) private locale: string,
    @Inject(PLATFORM_ID) private platformId: string
  ) {
    this.authenticated$ = authFacade.authenticated$;
  }

  canActivate(_route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    return this.authenticated$.pipe(
      map((authenticated) => {
        if (!authenticated && !isPlatformServer(this.platformId)) {
          window.location.href = this.keycloak
            .getKeycloakInstance()
            .createLoginUrl({
              redirectUri: window.location.origin + this.baseHref + state.url,
              locale: this.locale,
            })
            .concat('&reason=needsAuthForBusinessCard');
        }

        return true;
      })
    );
  }
}
